import { Tabs, Box } from "@mantine/core";
import { FC } from "react";
import { useSearchParams } from "react-router-dom";
import { AccountMainInfoPage } from "/@/pages/settings/AccountMainInfoPage";
import { DentistProductPreferences } from "./DentistProductPreferences";
import { NotificationSettings } from "./NotificationSettings";

export const SettingsPage: FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "MainInfo";

  const handleTabChange = (value: string | null) => {
    if (value) {
      setSearchParams({ tab: value });
    }
  };

  return (
    <Box p={{ base: "xs", sm: "md" }}>
      <Tabs value={activeTab} onChange={handleTabChange}>
        <Tabs.List w="fit-content">
          <Tabs.Tab h={50} value="MainInfo">
            Informations générales
          </Tabs.Tab>
          <Tabs.Tab h={50} value="ProductPreferences">
            Préférences prothèses
          </Tabs.Tab>
          <Tabs.Tab h={50} value="Notifications">
            Paramètres de notifications
          </Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="MainInfo">
          <AccountMainInfoPage />
        </Tabs.Panel>
        <Tabs.Panel value="ProductPreferences">
          <DentistProductPreferences />
        </Tabs.Panel>
        <Tabs.Panel value="Notifications">
          <NotificationSettings />
        </Tabs.Panel>
      </Tabs>
    </Box>
  );
};
